<!-- <div class="my-20">
    <div class="big-gray-circle" fxLayout="column" fxLayoutAlign="center center">
        <mat-icon>cloud_upload</mat-icon>
        <div style="color: #909090;font-size: 18px">
            {{'APP_PLATFORM_DOCUMENT_MANAGER.DMS_DROP_FILES_HERE'|translate}}
        </div>
        <div style="color: #909090; font-size: 13px;">
            {{'APP_PLATFORM_DOCUMENT_MANAGER.DMS_OR_USE_NEW_BUTTON'|translate}}
        </div>
    </div>
</div> -->
<div class="h-200" fxLayout="column" fxLayoutAlign="center center">
    <p class="mb-16" style="font-size: 24px">{{'NO_FILE_OR_FOLDER_FOUND'| translate}}</p>
</div>
